<div class="slider"><q-slider v-model="value"></q-slider><div class="cover" v-if="synapse.editable"></div></div>